export default function Goals() {
  const goals = [
    {
      icon: 'ri-shopping-basket-line',
      title: '5,000 Bakul Makanan',
      description: 'Sasaran agihan kepada ahli PBPKNM yang layak',
      color: 'emerald'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'RM150 Setiap Bakul',
      description: 'Nilai setiap bakul makanan yang diagihkan',
      color: 'amber'
    },
    {
      icon: 'ri-map-2-line',
      title: 'Seluruh Malaysia',
      description: 'Agihan merangkumi semua negeri di Malaysia',
      color: 'teal'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Keperluan Asas & Raya',
      description: 'Membantu keperluan harian dan persediaan Hari Raya',
      color: 'rose'
    }
  ];

  return (
    <section id="matlamat" className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-gradient-to-b from-white to-emerald-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            <i className="ri-target-line"></i>
            Matlamat Kempen
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 px-4">
            🎯 Matlamat Kempen
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Kempen ini mempunyai matlamat yang jelas untuk memastikan kebajikan bekas wira negara terjaga
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {goals.map((goal, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className={`w-12 h-12 sm:w-16 sm:h-16 bg-${goal.color}-100 rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${goal.icon} text-2xl sm:text-3xl text-${goal.color}-600`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">
                {goal.title}
              </h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                {goal.description}
              </p>
            </div>
          ))}
        </div>

        {/* Impact Banner */}
        <div className="mt-12 sm:mt-16 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-3xl p-6 sm:p-10 text-center text-white shadow-2xl">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">Impak Kempen</h3>
            <p className="text-sm sm:text-lg text-emerald-50 mb-6 sm:mb-8">
              Dengan mencapai matlamat ini, kita dapat membantu ribuan keluarga bekas anggota keselamatan yang telah berkhidmat untuk negara
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20">
                <div className="text-3xl sm:text-4xl font-bold text-amber-300 mb-2">RM750,000</div>
                <div className="text-xs sm:text-sm text-emerald-100">Jumlah Nilai Bantuan</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20">
                <div className="text-3xl sm:text-4xl font-bold text-amber-300 mb-2">5,000+</div>
                <div className="text-xs sm:text-sm text-emerald-100">Keluarga Terbantu</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20">
                <div className="text-3xl sm:text-4xl font-bold text-amber-300 mb-2">100%</div>
                <div className="text-xs sm:text-sm text-emerald-100">Telus & Beramanah</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
